module.exports = __webpack_public_path__ + "static/img/image.7b387187.png";